import React, { Component } from 'react';
import { useModal } from 'app/shared/contexts/ModalContext/useModal';

/**
 * Higher-Order Component to provide modal functionality to class components
 * This allows class components to access modal management functions
 */
export const withModal = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  const WithModalComponent = (props: P) => {
    const modal = useModal();

    return <WrappedComponent {...props} modal={modal} />;
  };

  WithModalComponent.displayName = `withModal(${WrappedComponent.displayName || WrappedComponent.name})`;

  return WithModalComponent;
};

export default withModal;
